import './EditDocumentTemplateExecutor.scss';
import React, { useEffect, useState } from 'react';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { sendNotification } from '@srm/ui/lib/notifications';
import { useForm } from 'react-hook-form';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import { DocumentTemplateFields } from '@organisms/actions/docExecutors/parts/DocumentTemplateFields';
import { accessTypeOption, templateAccessOf } from '@organisms/actions/docExecutors/parts/documentTemplateAccess';
import { IEditDocumentTemplateExecutorProps } from './IEditDocumentTemplateExecutorProps';
import { IEditDocumentTemplateFormData } from './IEditDocumentTemplateFormData';
import { RouteNames } from '@/router/router.types';
import { useUnsavedFormInput } from '@srm/ui/hooks/useUnsavedFormInput';

export const EditDocumentTemplateExecutorModal: React.FC<IEditDocumentTemplateExecutorProps> = (
    props: IEditDocumentTemplateExecutorProps,
) => {
    const [errorText, setErrorText] = useState<string>();
    // Подготовка (модель шаблона) и сохранение — разные состояния: подготовку можно бросить
    // закрытием окна, сохранение — нет.
    const [loading, setLoading] = useState<boolean>();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [initialAccess, setInitialAccess] = useState<string>();

    const service = new DocumentExecutionService(props.docId);

    const formState = useForm<IEditDocumentTemplateFormData>({
        mode: 'onBlur', // "onChange"
    });
    const hasUnsavedInput = useUnsavedFormInput(formState, { textFields: ['templateName'] });

    useEffect(() => {
        // Закрытое окно ответ подготовки не применяет.
        let ignore = false;
        setLoading(true);
        service
            .getEditDocumentTemplateModel(props.actionKey)
            .then((res) => {
                if (ignore) return;
                const access = res.data.templateAccess;
                const isDepartment = access !== '' && access !== '-1' && access !== null && access !== undefined;
                formState.reset({
                    templateName: res.data.templateName,
                    templateAccess: [accessTypeOption(access)],
                    deps: isDepartment ? access : '',
                });
                setInitialAccess(access ?? '');
            })
            .catch((error) => {
                if (!ignore) setErrorText(error);
            })
            .finally(() => {
                if (!ignore) setLoading(false);
            });
        return () => {
            ignore = true;
        };
    }, []);

    const onSubmit = (form: IEditDocumentTemplateFormData) => {
        const templateAccess = templateAccessOf(form.templateAccess?.[0]?.value, form.deps);

        setIsSubmitting(true);

        return service
            .editDocumentTemplate(props.actionKey, form.templateName, templateAccess)
            .then((result) => {
                sendNotification({
                    title: 'Шаблон документа успешно изменён',
                    message: `<a href=${RouteNames.DOCUMENT.replace(':id', result.data)}>Перейти к документу</a>`,
                    variant: 'green',
                });
                formState.reset({ templateName: '' });
                props.completeHandler && props.completeHandler(true);
            })
            .catch((error) => setErrorText(error))
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const modalContainerProps: IModalContainerProps = {
        header: props.title,
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: loading || isSubmitting,
        closeDisabled: isSubmitting,
        hasUnsavedInput,
        onCancel: () => {
            props.completeHandler && props.completeHandler(false);
        },
        errorText: errorText,
        formMethods: formState,
        onSubmit: onSubmit,
        okButtonDisabled: false,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            <DocumentTemplateFields formState={formState} initialAccess={initialAccess} />
        </ModalContainer>
    );
};
